import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { glassCardClass } from "@/recruitment/styles.js";

const MAIN_APP_LOGIN_URL = import.meta.env.VITE_MAIN_APP_LOGIN_URL || "https://kconnect.pl/login";

function redirectToSso(nextPath) {
  const targetUrl = `${window.location.origin}${nextPath}`;
  try {
    const loginUrl = new URL(MAIN_APP_LOGIN_URL, window.location.origin);
    loginUrl.searchParams.set("next", targetUrl);
    window.location.href = loginUrl.toString();
    return;
  } catch (_) {
    const fallback = new URL("https://kconnect.pl/login");
    fallback.searchParams.set("next", targetUrl);
    window.location.href = fallback.toString();
  }
}

export default function ParentEntryChoicePage() {
  return (
    <div className="mx-auto grid max-w-3xl gap-6">
      <Button asChild variant="outline" size="sm" className="w-fit">
        <Link to="/" className="inline-flex items-center gap-2">
          <ArrowLeft className="h-4 w-4" />
          Wróć
        </Link>
      </Button>

      <Card className={glassCardClass}>
        <CardHeader>
          <CardTitle>Jestem rodzicem</CardTitle>
          <CardDescription>Wybierz odpowiednią ścieżkę dostępu do rekrutacji.</CardDescription>
        </CardHeader>
        <CardContent className="grid gap-4 md:grid-cols-2">
          <Button size="lg" className="justify-between" onClick={() => redirectToSso("/parent")}>
            Używam już kconnect
            <ArrowRight className="h-4 w-4" />
          </Button>
          <Button asChild size="lg" variant="outline" className="justify-between">
            <Link to="/parent?mode=sign-up">
              Nie używam kconnect
              <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
